<section class="chat-container">
  <header class="chat-header">
    <section>
      <button class="channel-info-btn" [class.basic-chat]="channelData?.name === 'everyone'" (click)="openEditChannel($event)">
        <svg
          class="info-hashtag"
          width="32"
          height="33"
          viewBox="0 0 32 33"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M9.65649 28C9.23359 28 8.88859 27.8203 8.6215 27.4609C8.3544 27.1016 8.2765 26.7062 8.38779 26.275L9.32262 22.25H6.35119C5.90603 22.25 5.5499 22.0646 5.28281 21.6937C5.01571 21.3219 4.93781 20.9083 5.0491 20.4531C5.11587 20.1177 5.27168 19.8542 5.51652 19.6625C5.76135 19.4708 6.03958 19.375 6.35119 19.375H9.99036L11.3258 13.625H7.68666C7.2415 13.625 6.88538 13.4396 6.61828 13.0687C6.35119 12.6969 6.27328 12.2833 6.38457 11.8281C6.45135 11.4927 6.60715 11.2292 6.85199 11.0375C7.09683 10.8458 7.37505 10.75 7.68666 10.75H11.9936L13.0953 6.04219C13.1621 5.73073 13.3068 5.47917 13.5294 5.2875C13.7519 5.09583 14.019 5 14.3307 5C14.7536 5 15.0986 5.17969 15.3656 5.53906C15.6327 5.89844 15.7106 6.29375 15.5994 6.725L14.6645 10.75H20.0064L21.1082 6.04219C21.175 5.73073 21.3196 5.47917 21.5422 5.2875C21.7648 5.09583 22.0319 5 22.3435 5C22.7664 5 23.1114 5.17969 23.3785 5.53906C23.6456 5.89844 23.7235 6.29375 23.6122 6.725L22.6774 10.75H25.6488C26.094 10.75 26.4501 10.9354 26.7172 11.3063C26.9843 11.6781 27.0622 12.0917 26.9509 12.5469C26.8841 12.8823 26.7283 13.1458 26.4835 13.3375C26.2386 13.5292 25.9604 13.625 25.6488 13.625H22.0096L20.6742 19.375H24.3133C24.7585 19.375 25.1146 19.5604 25.3817 19.9313C25.6488 20.3031 25.7267 20.7167 25.6154 21.1719C25.5487 21.5073 25.3928 21.7708 25.148 21.9625C24.9032 22.1542 24.6249 22.25 24.3133 22.25H20.0064L18.9047 26.9578C18.8379 27.2693 18.6932 27.5208 18.4706 27.7125C18.2481 27.9042 17.981 28 17.6693 28C17.2464 28 16.9014 27.8203 16.6344 27.4609C16.3673 27.1016 16.2894 26.7062 16.4006 26.275L17.3355 22.25H11.9936L10.8918 26.9578C10.825 27.2693 10.6804 27.5208 10.4578 27.7125C10.2352 27.9042 9.9681 28 9.65649 28ZM12.6613 19.375H18.0032L19.3387 13.625H13.9968L12.6613 19.375Z"
            fill="black"
          />
        </svg>
        <span class="channel-name" title="Kanal bearbeiten">{{
          channelData?.name
        }}</span>
        <svg
          class="info-arrow"
          width="30"
          height="31"
          viewBox="0 0 30 31"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M15 19.5938C14.8326 19.5938 14.6706 19.5625 14.5141 19.5C14.3567 19.4375 14.2257 19.3542 14.1211 19.25L8.34529 13.5C8.1151 13.2708 8 12.9792 8 12.625C8 12.2708 8.1151 11.9792 8.34529 11.75C8.57549 11.5208 8.86846 11.4062 9.22422 11.4062C9.57997 11.4062 9.87294 11.5208 10.1031 11.75L15 16.625L19.8969 11.75C20.1271 11.5208 20.42 11.4062 20.7758 11.4062C21.1315 11.4062 21.4245 11.5208 21.6547 11.75C21.8849 11.9792 22 12.2708 22 12.625C22 12.9792 21.8849 13.2708 21.6547 13.5L15.8789 19.25C15.7534 19.375 15.6173 19.4633 15.4709 19.515C15.3244 19.5675 15.1674 19.5938 15 19.5938Z"
            fill="black"
          />
        </svg>
      </button>
    </section>

    <section class="users-and-add-users">
      <button
        class="avatar-stack"
        #membersBtn
        type="button"
        (click)="openMembersDialog($event, membersBtn)"
        aria-label="Mitglieder anzeigen"
      >
        <ng-container *ngIf="avatarPreview$ | async as preview">
          <span class="member-count" *ngIf="memberCount$ | async as c">{{ c }}</span>
          <img
            *ngFor="let m of preview; let i = index"
            class="avatar"
            [style.zIndex]="10 - i"
            [src]="m.avatar || 'assets/img-profile/profile.png'"
            [alt]="m.name || 'User'"
            [title]="m.name || ''"
          />
        </ng-container>
      </button>
      <button class="add-user-btn" #headerAddIcon (click)="onAddUserClick($event, headerAddIcon)">
        <svg
          width="40"
          height="40"
          viewBox="0 0 40 40"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect width="40" height="40" rx="20" fill="#ECEEFE" />
          <mask
            id="mask0_1823_16668"
            style="mask-type: alpha"
            maskUnits="userSpaceOnUse"
            x="8"
            y="8"
            width="24"
            height="24"
          >
            <rect x="8" y="8" width="24" height="24" fill="#D9D9D9" />
          </mask>
          <g mask="url(#mask0_1823_16668)">
            <path
              d="M27 22C26.7167 22 26.4793 21.904 26.288 21.712C26.096 21.5207 26 21.2833 26 21V19H24C23.7167 19 23.4793 18.904 23.288 18.712C23.096 18.5207 23 18.2833 23 18C23 17.7167 23.096 17.479 23.288 17.287C23.4793 17.0957 23.7167 17 24 17H26V15C26 14.7167 26.096 14.479 26.288 14.287C26.4793 14.0957 26.7167 14 27 14C27.2833 14 27.5207 14.0957 27.712 14.287C27.904 14.479 28 14.7167 28 15V17H30C30.2833 17 30.5207 17.0957 30.712 17.287C30.904 17.479 31 17.7167 31 18C31 18.2833 30.904 18.5207 30.712 18.712C30.5207 18.904 30.2833 19 30 19H28V21C28 21.2833 27.904 21.5207 27.712 21.712C27.5207 21.904 27.2833 22 27 22ZM17 20C15.9 20 14.9583 19.6083 14.175 18.825C13.3917 18.0417 13 17.1 13 16C13 14.9 13.3917 13.9583 14.175 13.175C14.9583 12.3917 15.9 12 17 12C18.1 12 19.0417 12.3917 19.825 13.175C20.6083 13.9583 21 14.9 21 16C21 17.1 20.6083 18.0417 19.825 18.825C19.0417 19.6083 18.1 20 17 20ZM10 28C9.71667 28 9.47933 27.904 9.288 27.712C9.096 27.5207 9 27.2833 9 27V25.2C9 24.6333 9.146 24.1123 9.438 23.637C9.72933 23.1623 10.1167 22.8 10.6 22.55C11.6333 22.0333 12.6833 21.6457 13.75 21.387C14.8167 21.129 15.9 21 17 21C18.1 21 19.1833 21.129 20.25 21.387C21.3167 21.6457 22.3667 22.0333 23.4 22.55C23.8833 22.8 24.2707 23.1623 24.562 23.637C24.854 24.1123 25 24.6333 25 25.2V27C25 27.2833 24.904 27.5207 24.712 27.712C24.5207 27.904 24.2833 28 24 28H10ZM11 26H23V25.2C23 25.0167 22.9543 24.85 22.863 24.7C22.771 24.55 22.65 24.4333 22.5 24.35C21.6 23.9 20.6917 23.5623 19.775 23.337C18.8583 23.1123 17.9333 23 17 23C16.0667 23 15.1417 23.1123 14.225 23.337C13.3083 23.5623 12.4 23.9 11.5 24.35C11.35 24.4333 11.2293 24.55 11.138 24.7C11.046 24.85 11 25.0167 11 25.2V26ZM17 18C17.55 18 18.021 17.804 18.413 17.412C18.8043 17.0207 19 16.55 19 16C19 15.45 18.8043 14.9793 18.413 14.588C18.021 14.196 17.55 14 17 14C16.45 14 15.9793 14.196 15.588 14.588C15.196 14.9793 15 15.45 15 16C15 16.55 15.196 17.0207 15.588 17.412C15.9793 17.804 16.45 18 17 18Z"
              fill="black"
            />
          </g>
        </svg>
      </button>
    </section>
  </header>
  <main
    #messagesContainer
    class="chat-content"
    *ngIf="messages$ | async as messages"
    [class.empty]="messages.length === 0"
  >
    @if (messages.length === 0) {
    <section>
      <button class="channel-info-btn" [class.basic-chat]="channelData?.name === 'everyone'">
        <svg
          class="info-hashtag"
          width="32"
          height="33"
          viewBox="0 0 32 33"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M9.65649 28C9.23359 28 8.88859 27.8203 8.6215 27.4609C8.3544 27.1016 8.2765 26.7062 8.38779 26.275L9.32262 22.25H6.35119C5.90603 22.25 5.5499 22.0646 5.28281 21.6937C5.01571 21.3219 4.93781 20.9083 5.0491 20.4531C5.11587 20.1177 5.27168 19.8542 5.51652 19.6625C5.76135 19.4708 6.03958 19.375 6.35119 19.375H9.99036L11.3258 13.625H7.68666C7.2415 13.625 6.88538 13.4396 6.61828 13.0687C6.35119 12.6969 6.27328 12.2833 6.38457 11.8281C6.45135 11.4927 6.60715 11.2292 6.85199 11.0375C7.09683 10.8458 7.37505 10.75 7.68666 10.75H11.9936L13.0953 6.04219C13.1621 5.73073 13.3068 5.47917 13.5294 5.2875C13.7519 5.09583 14.019 5 14.3307 5C14.7536 5 15.0986 5.17969 15.3656 5.53906C15.6327 5.89844 15.7106 6.29375 15.5994 6.725L14.6645 10.75H20.0064L21.1082 6.04219C21.175 5.73073 21.3196 5.47917 21.5422 5.2875C21.7648 5.09583 22.0319 5 22.3435 5C22.7664 5 23.1114 5.17969 23.3785 5.53906C23.6456 5.89844 23.7235 6.29375 23.6122 6.725L22.6774 10.75H25.6488C26.094 10.75 26.4501 10.9354 26.7172 11.3063C26.9843 11.6781 27.0622 12.0917 26.9509 12.5469C26.8841 12.8823 26.7283 13.1458 26.4835 13.3375C26.2386 13.5292 25.9604 13.625 25.6488 13.625H22.0096L20.6742 19.375H24.3133C24.7585 19.375 25.1146 19.5604 25.3817 19.9313C25.6488 20.3031 25.7267 20.7167 25.6154 21.1719C25.5487 21.5073 25.3928 21.7708 25.148 21.9625C24.9032 22.1542 24.6249 22.25 24.3133 22.25H20.0064L18.9047 26.9578C18.8379 27.2693 18.6932 27.5208 18.4706 27.7125C18.2481 27.9042 17.981 28 17.6693 28C17.2464 28 16.9014 27.8203 16.6344 27.4609C16.3673 27.1016 16.2894 26.7062 16.4006 26.275L17.3355 22.25H11.9936L10.8918 26.9578C10.825 27.2693 10.6804 27.5208 10.4578 27.7125C10.2352 27.9042 9.9681 28 9.65649 28ZM12.6613 19.375H18.0032L19.3387 13.625H13.9968L12.6613 19.375Z"
            fill="black"
          />
        </svg>
        <span class="channel-name">{{ channelData?.name }}</span>
        <svg
          class="info-arrow arrow-visibility"
          width="30"
          height="31"
          viewBox="0 0 30 31"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M15 19.5938C14.8326 19.5938 14.6706 19.5625 14.5141 19.5C14.3567 19.4375 14.2257 19.3542 14.1211 19.25L8.34529 13.5C8.1151 13.2708 8 12.9792 8 12.625C8 12.2708 8.1151 11.9792 8.34529 11.75C8.57549 11.5208 8.86846 11.4062 9.22422 11.4062C9.57997 11.4062 9.87294 11.5208 10.1031 11.75L15 16.625L19.8969 11.75C20.1271 11.5208 20.42 11.4062 20.7758 11.4062C21.1315 11.4062 21.4245 11.5208 21.6547 11.75C21.8849 11.9792 22 12.2708 22 12.625C22 12.9792 21.8849 13.2708 21.6547 13.5L15.8789 19.25C15.7534 19.375 15.6173 19.4633 15.4709 19.515C15.3244 19.5675 15.1674 19.5938 15 19.5938Z"
            fill="black"
          />
        </svg>
      </button>
      <p class="channel-intro">
        Channel wurde erstellt. Das ist der Anfang des Channels&nbsp;
        <span class="current-channel">
          <img src="assets/icons/small-hashtag.svg" alt="hashtag" />
          <span>{{ channelData?.name }}</span>
        </span>
        .
      </p>
    </section>
    } @else { @for(message of messages; track message.id) {
    <app-message-bubble
      [incoming]="message.authorId !== currentUserId"
      [name]="
        message.authorId !== currentUserId ? memberProfiles[message.authorId]?.name || '' : 'Du'
      "
      [avatar]="
        message.authorId !== currentUserId
          ? memberProfiles[message.authorId]?.avatar || 'assets/img-profile/profile.png'
          : currentUserProfile()?.avatar ?? 'assets/img-profile/profile.png'
      "
      [authorId]="message.authorId"
      [time]="
        message.time
          ? message.time + ' Uhr'
          : message.timestamp
          ? (message.timestamp.toDate() | date : 'HH:mm') + ' Uhr'
          : ''
      "
      [text]="message.text ?? ''"
      [edited]="message.edited"
      [chatId]="chatId || ''"
      [messageId]="message.id"
      [reactionsMap]="message.reactions"
      collectionName="channels"
    ></app-message-bubble>
    @if (message.showDateSeparator) {
    <section class="timestamp-block">
      <p class="timestamp-line"></p>
      <div class="timestamp-bubble">
        <span class="message-timestamp">{{
          isTodaysMessage(message.timestamp)
            ? 'Heute'
            : (message.timestamp?.toDate() | date : 'EEEE, d. MMMM')
        }}</span>
      </div>
      <p class="timestamp-line"></p>
    </section>
    } } }
  </main>
  <footer class="footer">
    <app-message-area-component
      [channelName]="channelData?.name || ''"
      (send)="handleNewMessage($event)"
    ></app-message-area-component>
  </footer>
</section>
